
  import Events from '@/events/Events';
  import OrganizationDetails from '@/components/OrganizationDetails.vue';
  import OrganizationJobPostings from '@/components/OrganizationJobPostings.vue';
  import OrganizationActivitiesAndIndustries from '@/components/OrganizationActivitiesAndIndustries.vue';
  export default {
    name: 'SectionOrganizationDetails',
    components: {
      OrganizationDetails,
      OrganizationJobPostings,
      OrganizationActivitiesAndIndustries,
    },
    props: {
      section: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        activities: null,
        latitude: null,
        longitude: null,
        distance: null,
        organization: {
          '@type': 'Organization',
          '@id':
            '/promotionbasis/organizations/b99ae210-73db-44c8-9d02-139302d958ee',
          id: 'b99ae210-73db-44c8-9d02-139302d958ee',
          slug: 'hairfree-boeblingen',
          name: 'hairfree Böblingen',
          street: 'Battnerstr. 4',
          zipcode: 'D-71701',
          city: 'Schwieberdingen',
          contactPerson: 'Herr Thanh Hai Truong',
          phoneCentral: '',
          phoneMobile: '0049-0173-4320154',
          fax: '',
          email: 'hai.truong@partner.hairfree.com',
          homepage: 'http://www.hairfree.com',
          shortDescription: 'Short description',
          description: 'Some more text....',
          facebookProfile: 'https://facebook.com',
          instagramProfile: 'https://instagram.com',
          twitterProfile: '',
          linkedInProfile: 'https://linkedin.com',
          xingProfile: 'https://xing.com',
          foundingYear: 1991,
          numberOfEmployees: 0,
          numberOfWorkingDaysPerYear: 0,
          industries: 'industrie1,industrie2',
          activities: 'activitie1, activitie2',
          isActive: true,
          publicProfile: true,
          ratingGrade: 3.5,
          ratingsNumber: 120,
          fotoRdmCode: 'MTYwOF81ZTY2NWE5YmRjOGNjYjRiYjU1NzBlZjhhMjI3NjdiYg==',
        },
      };
    },
    mounted() {
      this.$emitWithClientData(Events.OrganizationDetailsViewed, {
        organizationId: this.organization.id,
      });
    },
    created() {
      this.organization = this.section.organization;
      if (this.section.activities) {
        this.activities = this.section.activities;
      }
      if (this.section.latitude) {
        this.latitude = this.section.latitude;
      }
      if (this.section.longitude) {
        this.longitude = this.section.longitude;
      }
      if (this.section.distance) {
        this.distance = this.section.distance;
      }
    },
  };
